import React, { useEffect, useRef, useState } from "react";
import query from "jquery";
import { Link, NavLink, useNavigate, useSearchParams } from "react-router-dom";

const HeaderOne = () => {
 return (

   <header className="header-middle ">
           <div className="container container-md">
             <nav className="header-inner flex-between">
               {/* Logo Start */}
               {/* Logo End  */}
               {/* form location Start */}
               <div className="logo">
                 <Link to="/" className="link">
                   <img src="/assets/images/logo/logo-iWant-Asia.png" alt="Logo" />
                 </Link>
               </div>
               <div className="d-lg-none d-block"></div>
               {/* form location start */}
               {/* Header Middle Right start */}
             
               {/* Header Middle Right End  */}
             </nav>
           </div>
         </header>


  );
};

export default HeaderOne;